import { makeStyles, Theme } from "@material-ui/core/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  root: {
    flexGrow: 1,
    backgroundColor: theme.palette.background.paper,
    display: 'flex',
    height: '83%',
  },
  tabs: {
    borderRight: `1px solid ${theme.palette.divider}`,
  },
  tab: {
    textTransform: 'none',
    height: 35,
    fontSize: 12,
  },
  tabSelected: {
    textTransform: 'none',
    height: 35,
    fontSize: 12,
    backgroundColor: '#ededed',
  },
  formControl: {
    padding: theme.spacing(1),
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  translationItem: {
    paddingLeft: 40,
    color: 'grey',
    textTransform: 'none',
  },
}));
